<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>銷售應用中心</b-breadcrumb-item>
            <b-breadcrumb-item active>訂單管理</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <Order />
    </b-card>
  </div>
</template>

<script>
import Order from "@/components/Dashboard/Order/Order.vue";

export default {
  components: {
    Order,
  },
};
</script>
